import {
  take as _take,
  takeEvery as _takeEvery,
  takeLatest as _takeLatest,
  all,
  call,
} from 'redux-saga/effects';
import { requestForSaga } from 'utils/request/request';

import { isNonNullable } from '@ipfabric/utils';
import get from 'lodash/get';
import { serializeError } from 'serialize-error';
import { LOG_ERROR } from './constants';

export function tryCatch(saga) {
  const wrapped = function* wrappedTryCatch(...args) {
    try {
      yield call(saga, ...args);
    } catch (error) {
      // Because application is not fully prepared to handle errors in sagas, due to the fact that sagas are
      // terminated when an error is thrown and let buble to root of saga, we need propagate the error to the
      // application notification system with dispatching a custom event. This event is handled and processed
      // by the useErrorHandler hook.
      window.dispatchEvent(
        new CustomEvent('sagaError', { detail: { error, origin: 'SAGA' } }),
      );
    }
  };
  return wrapped;
}

export function take(pattern, worker, ...args) {
  return _take(pattern, tryCatch(worker), ...args);
}

export function takeEvery(pattern, worker, ...args) {
  return _takeEvery(pattern, tryCatch(worker), ...args);
}

export function takeLatest(pattern, worker, ...args) {
  return _takeLatest(pattern, tryCatch(worker), ...args);
}

function isIgnoredError(error, isApiError) {
  return (
    (isApiError &&
      (error.code === 'API_EXPIRED_ACCESS_TOKEN' ||
        error.code === 'API_INVALID_REFRESH_TOKEN' ||
        error.code === 'API_INVALID_ACCESS_TOKEN' ||
        error.code === 'API_MAINTENANCE_IN_PROGRESS' ||
        error.code === 'API_LICENSE_NOT_FOUND')) ||
    error.type === 'INSUFFICIENT_RIGHTS'
  );
}

export const getErrorMessage = (e) => {
  const message = [
    ...(e.code ? [e.code] : []),
    get(get(e, ['errors', 0], e), 'message', e),
    ...(e.payload?.url ? [`request url: ${e.payload.url}\n`] : []),
    // use stack from payload, instead of from error, if present. This is used in async thrown stumble
    e.payload?.stack ? e.payload.stack : get(serializeError(e), 'stack', e),
  ];

  return message.join('\n');
};

export function* logErrorSaga(action) {
  try {
    const { origin, error } = action.payload;
    const apiError = isNonNullable(error.message) && isNonNullable(error.code);

    if (!isIgnoredError(error, apiError)) {
      const message = `${origin}: ${getErrorMessage(error)}`;
      yield call(requestForSaga, {
        url: '/os/logs',
        method: 'POST',
        data: { data: message },
      });
    }
  } catch {
    // don't rethrow error if logging fails
  }
}

export function* defaultSaga() {
  yield all([takeEvery(LOG_ERROR, logErrorSaga)]);
}

// All sagas to be loaded
export default defaultSaga;
